export const LOA_STATUS_LABELS = {
  1: "Submitted",
  2: "Under Review",
  3: "Approved",
  4: "Rejected",
};

export const LOA_STATUS_BADGE_CLASSES = {
  1: "bg-gray-200 text-gray-700",
  2: "bg-yellow-100 text-yellow-800",
  3: "bg-green-100 text-green-700",
  4: "bg-red-100 text-red-700",
};

export const getLoaStatusLabel = (status) => LOA_STATUS_LABELS[status] ?? `Unknown (${status})`;
